import React, { ReactElement, useState } from 'react'
import SearchSelect from '../formGroup/SearchSelect'
import MySelect from '../formGroup/MySelect'
import { ResidenceFiscale } from './Options'
import Step5ResidenceFiscaleHook from '../../hooks/Step5ResidenceFiscaleHook'
import { IStep5ResidenceFiscale } from '../../interfaces/Step5'
import DomicileFiscale from './DomicileFiscale'
import TextInput from '../formGroup/TextInput'
import { getItemSuffix } from '../../utils/getItemSuffix'
import { AUTRE } from '../../enums/common'
import { IOption } from '../../interfaces/FormFields'

function Step5ResidenceFiscale(props: IStep5ResidenceFiscale): ReactElement {
  const { fiscalCountriesList, folderData, form, item, removeState } = props
  const {
    fiscalAddressCountryAutre,
    pays_residence_ficale,
    handleFiscalAddressCountryChange,
    handleTaxCountryOtherChange,
    domicileFiscaleType,
    fiscalAddressCountryFrance,
  } = Step5ResidenceFiscaleHook(props)

  const { register, triggerValidation, errors, watch, setValue, control } = form
  const fiscalAddressCountrySuffix = `fiscal_address_country${getItemSuffix(
    item
  )}`
  const taxCountryOtherSuffix = `tax_country_other${getItemSuffix(item)}`
  const identifiantFiscaleSuffix = `identifiant_fiscale${getItemSuffix(item)}`
  const fiscal_address_country = folderData[fiscalAddressCountrySuffix]
  const tax_country_other = folderData[taxCountryOtherSuffix]

  const countries =
    watch(fiscalAddressCountrySuffix) === AUTRE
      ? fiscalCountriesList.filter(
          ({ value }) => !['FRA', 'MCO'].includes(value)
        )
      : fiscalCountriesList

  const defaultValue = countries.find(
    (county) => county.value === tax_country_other
  )
  const [addressCountry, setAddressCountry] = useState()

  const handleOnChangeCountry = (selected: IOption | null) => {
    if (selected) {
      setAddressCountry(selected)
      handleTaxCountryOtherChange(selected.value, taxCountryOtherSuffix)
      setValue('adresse_pays', selected ? selected.value : '')
    }
    return selected ? selected.value : selected
  }

  return (
    <>
      <div className="colLg6 colXl4 mb4">
        <MySelect
          options={ResidenceFiscale}
          value={fiscal_address_country || ''}
          register={register({ required: true })}
          name={fiscalAddressCountrySuffix}
          id={fiscalAddressCountrySuffix}
          error={errors[fiscalAddressCountrySuffix]}
          label="Résidence fiscale"
          onChange={(e) => {
            handleFiscalAddressCountryChange(e, fiscalAddressCountrySuffix)
            if (e.target.value !== AUTRE) {
              removeState?.(item ? 2 : 1)
            }
          }}
          required
        />
      </div>

      {fiscalAddressCountryFrance && (
        <div className="colLg6 colXl4 mb6lg mb2">
          <TextInput
            defaultValue=""
            register={register({ required: true })}
            name={identifiantFiscaleSuffix}
            id={identifiantFiscaleSuffix}
            error={errors[identifiantFiscaleSuffix]}
            inputClassName="inputFieldSecondary"
            label="Identifiant fiscal"
            triggerValidation={triggerValidation}
            required
          />
        </div>
      )}

      {fiscalAddressCountryAutre && (
        <div className="colXl4 colLg6 mb6lg mb2">
          <SearchSelect
            id="taxCountryOtherSuffix"
            name={taxCountryOtherSuffix}
            label="Pays"
            placeHolder="Sélectionner"
            options={countries}
            value={
              defaultValue && !addressCountry ? defaultValue : addressCountry
            }
            control={control}
            rules={{
              required: true,
            }}
            required
            register={register}
            error={errors[taxCountryOtherSuffix]}
            onChange={handleOnChangeCountry}
          />
        </div>
      )}
      <input
        type="hidden"
        name={`pays_residence_ficale${getItemSuffix(item)}`}
        value={pays_residence_ficale || ''}
        ref={register}
      />
      <DomicileFiscale type={domicileFiscaleType} {...{ ...props }} />
    </>
  )
}

export default Step5ResidenceFiscale
